import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import { InputComponent } from '../../../shared/input/input.component';
import { InputDateTimeComponent } from '../../../shared/input-datetime/input-datetime.component';
import { RowComponent } from '../../../shared/row/row.component';
import { HeroReport } from '../../../model/hero-report/hero-report.model';
import { mgrsValidator } from '../../../utilities/location';
import {
  MAX_ADDITIONAL_COMMENTS_LENGTH,
  MAX_MGRS_LENGTH,
  MAX_REPORTER_TITLE_LENGTH,
  MAX_SHORT_TEXT_LENGTH,
  parseOptionalNumber,
} from '../../../utilities/sreReport';

/** Depth and distance are optional, but when given they must be a plain non-negative number. */
function optionalNumberValidator(control: AbstractControl): ValidationErrors | null {
  return Number.isNaN(parseOptionalNumber(control.value)) ? { number: true } : null;
}

/**
 * The SRE details form. Only MGRS is required; the limits match the API (MGRS 50, parcel and
 * lane 50, title of reporter 255, additional comments 4000).
 */
export function buildSreDetailsForm(fb: FormBuilder, heroReport?: Partial<HeroReport>): FormGroup {
  return fb.group({
    mgrs: [heroReport?.mgrs ?? '', [Validators.required, Validators.maxLength(MAX_MGRS_LENGTH), mgrsValidator]],
    depthCm: [heroReport?.depthCm ?? null, [optionalNumberValidator]],
    parcelNumber: [heroReport?.parcelNumber ?? '', [Validators.maxLength(MAX_SHORT_TEXT_LENGTH)]],
    laneNumber: [heroReport?.laneNumber ?? '', [Validators.maxLength(MAX_SHORT_TEXT_LENGTH)]],
    distance: [heroReport?.distance ?? null, [optionalNumberValidator]],
    pocName: [heroReport?.pocName ?? ''],
    reporterTitle: [heroReport?.reporterTitle ?? '', [Validators.maxLength(MAX_REPORTER_TITLE_LENGTH)]],
    firstNoticedDate: [heroReport?.firstNoticedDate ? new Date(heroReport.firstNoticedDate) : new Date()],
    additionalComments: [
      heroReport?.additionalComments ?? '',
      [Validators.maxLength(MAX_ADDITIONAL_COMMENTS_LENGTH)],
    ],
  });
}

@Component({
  selector: 'app-sre-details-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, InputComponent, InputDateTimeComponent, RowComponent],
  templateUrl: './sre-details-form.component.html',
})
export class SreDetailsFormComponent {
  @Input() formGroup!: FormGroup;

  readonly maxComments = MAX_ADDITIONAL_COMMENTS_LENGTH;
}
